/** Does the session hold a DECISION the close would throw away? Not "has the plan changed": a
 * preview restores, a decision does not. */
import type { StudioDraft } from "../domain/studioTypes";

export interface StudioDirtyInput {
  undoDepth: number;
  resolverHasChanges: boolean;
  regenerated: boolean;
  blockingFixStaged: boolean;
  draft: Pick<
    StudioDraft,
    "dismissedFlagIds" | "restrictions" | "appliedFixFlagIds" | "acceptedFlagIds"
  >;
}

export const studioIsDirty = (input: StudioDirtyInput): boolean =>
  input.undoDepth > 0 ||
  input.resolverHasChanges ||
  input.regenerated ||
  input.blockingFixStaged ||
  input.draft.dismissedFlagIds.length > 0 ||
  input.draft.restrictions.length > 0 ||
  input.draft.appliedFixFlagIds.length > 0 ||
  (input.draft.acceptedFlagIds?.length ?? 0) > 0;
